(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-signage-product-FIXED"] && !Shopify.designMode) return;
  try {
    
if (!window.nqSignageProductTracking) {
  window.nqSignageProductTracking = true;
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-nq-product-track]');
    if (!link) return;
    const root = link.closest('[data-nq-signage-product]');
    const details = { enquiry_type: 'signage', page_slug: root.dataset.pageSlug, cta_position: link.dataset.ctaPosition, cta_label: link.textContent.trim() };
    if (typeof window.gtag === 'function') window.gtag('event', link.dataset.nqProductTrack, details);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({event: link.dataset.nqProductTrack}, details));
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-signage-product"] && !Shopify.designMode) return;
  try {
    
if (!window.nqSignageProductTracking) {
  window.nqSignageProductTracking = true;
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-nq-product-track]');
    if (!link) return;
    const root = link.closest('[data-nq-signage-product]');
    const details = { enquiry_type: 'signage', page_slug: root.dataset.pageSlug, cta_position: link.dataset.ctaPosition, cta_label: link.textContent.trim() };
    if (typeof window.gtag === 'function') window.gtag('event', link.dataset.nqProductTrack, details);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({event: link.dataset.nqProductTrack}, details));
  });
}

  } catch(e) { console.error(e); }
})();
})();
